
import { Base } from '../base-component';

import { AnalyticsService } from '../../services/analytics.service';
import { TooltipsService } from '../../services/tooltips.service';

import './detailed-product-card-exchange.component.scss';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import * as $ from 'jquery';

export class DetailedProductCardExchange extends Base {

	productKey: any;
	supportedCurrenciesRendered: boolean;

	// containers
	containerCurrencies: any;
	containerButtons: any;
	containerEligibilityMessage: any;

	// buttons
	currencyButtons: any;
	currencyPricingCards: any;
	currencyPricingTerms: any;

	// storage
	currencyStorage: any;
	eligibilityStorage: any;
	queryStringCheck: any;
	queryStringValue: any;

	constructor(element: Element) {

		super(element);

	}

	init() {

		// referral
		let pattern = /[?&]ifa=/;
		let getUrl = location.search;

		if(pattern.test(getUrl))
		{
			this.queryStringValue = this.urlParams('ifa');
			this.queryStringCheck = true;

		}else{
			this.queryStringCheck = false;
		}

		this.supportedCurrenciesRendered = false;
		let storageCurrency: any = localStorage.getItem('currency');
		let storageEligibility: any = localStorage.getItem('eligibility');

		this.productKey = this.element.getAttribute('data-productkey');
		this.containerCurrencies = Array.from(this.element.querySelectorAll('.detailed-product-card-exchange__currencies--items'));
		this.currencyButtons = Array.from(this.element.querySelectorAll('.detailed-product-card-exchange__currencies--item'));
		this.containerButtons = Array.from(this.element.querySelectorAll('.detailed-product-card-exchange__buttons-js'));
		this.currencyPricingCards = Array.from(this.element.querySelectorAll('.detailed-product-card-exchange__currency-js'));
		this.containerEligibilityMessage = this.element.querySelector('.detailed-product-card-exchange__eligibility-message');
		this.currencyPricingTerms = Array.from(this.element.querySelectorAll('.product-offering-exchange__terms'));

		if (!storageCurrency) {
			storageCurrency = {};
			storageCurrency = "";
			localStorage.setItem('currency', JSON.stringify(storageCurrency));
		} else {
			storageCurrency = JSON.parse(storageCurrency);
			if (!storageCurrency) {
				storageCurrency = "";
				localStorage.setItem('currency', JSON.stringify(storageCurrency));
			}
		}

		if (!storageEligibility) {
			storageEligibility = {};
			localStorage.setItem('eligibility', JSON.stringify(storageEligibility));
		} else {
			storageEligibility = JSON.parse(storageEligibility);
		}

		this.currencyStorage = storageCurrency;
		this.eligibilityStorage = storageEligibility;

		this.currencySelected();
		this.currencyCards();
		this.buttonContainer(this.eligibilityStorage);		

		TooltipsService.initTooltips();

	}

	bindEvents() {

		if (this.currencyButtons) {
			this.currencyButtons.map((item) => item.addEventListener('click', (event) => {
				this.currencyClick(event);
			}));
		}

		$(document).on('click', '.js-recheck-eligibility', (e) => {
			let element = e.target;
			this.recheckEligibility(element);
		});

		$(document).on('click', 'div.detailed-product-card-exchange__buttons-js[data-buttonclass=Apply]', (e) => {
			let element: any;
			if(e.currentTarget){
				element = e.currentTarget;
			}else{
				element = e.target;
			}
			let getAnchor = element.querySelector('a');
			let getLeadId = getAnchor.getAttribute('data-leadid');
			let getProductName = getAnchor.getAttribute('data-productname');
			this.actionApplyNow(getLeadId, getProductName);
		});

	}

	currencyClick(event: any) {
		if (event) {
			let element = event.target;
			let currency: any = element.getAttribute('data-currency');
			this.currencyButtons.forEach(button => {
				button.classList.remove('detailed-product-card-exchange__currencies--item__active');
			});
			element.classList.add('detailed-product-card-exchange__currencies--item__active');
			this.currencyStorage = currency;
			localStorage.setItem('currency', JSON.stringify(this.currencyStorage));
			this.currencyCards(currency);
		}
	}

	currencySelected() {
		this.currencyButtons.map((element) => {
			let currency: any = element.getAttribute('data-currency');
			if (currency == this.currencyStorage) {
				element.classList.add('detailed-product-card-exchange__currencies--item__active');
			}
		});
	}

	currencyCards(currency: any = '') {
		this.currencyPricingCards.map((element) => {
			let currencyCard: any = element.getAttribute('data-currency');
			let currencyCardTitle: any = element.querySelector('.detailed-product-card-exchange__description');
			this.currencyCardTitle(currencyCardTitle);
			if(currencyCard){
				element.classList.add('d-none');
			}else{
				element.classList.remove('d-none');
			}
			if(currency) {
				if (currencyCard == currency) {
					element.classList.remove('d-none');
				}
			}else{
				if(this.currencyStorage) {
					if (currencyCard == this.currencyStorage) {
						element.classList.remove('d-none');
					}
				}else{
					if (currencyCard == "GBP") {
						element.classList.remove('d-none');
					}
				}
			}
		});
		this.currencyPricingTerms.map((element) => {
			let currencyCard: any = element.getAttribute('data-currency-value');
			if(currencyCard){
				element.classList.add('d-none');
			}else{
				element.classList.remove('d-none');
			}
			if(currency) {
				if (currencyCard == currency) {
					element.classList.remove('d-none');
				}
			}else{
				if(this.currencyStorage) {
					if (currencyCard == this.currencyStorage) {
						element.classList.remove('d-none');
					}
				}else{
					if (currencyCard == "GBP") {
						element.classList.remove('d-none');
					}
				}
			}
		})
		this.supportedCurrenciesRendered = true;
	}

	currencyCardTitle(element: any) {
		if(!this.supportedCurrenciesRendered) {
			let elementHtml = element.innerHTML;
			elementHtml = elementHtml.trim().replace(/ /g,"");
			elementHtml = elementHtml.toLowerCase();
			if(elementHtml == 'supportedcurrencies'){
				let closestContainer = element.closest('.detailed-product-card-exchange__currency-js');
				let valueContainer = closestContainer.querySelector('.detailed-product-card-exchange__item-title');
				valueContainer.classList.add('product-offering-exchange__pricing-title--small');
				let value = valueContainer.innerHTML;
				value = value.trim().replace(/ /g,"");		
	
				let output = "";
				let outputOther = "SUPPORTED CURRENCIES:<br>";	
				let splittedCurrencies = value.split(',');	
	
				if(splittedCurrencies.length > 5){	
					valueContainer.innerHTML = "";	
					for (let index = 0; index < 5; index++) {
						output += splittedCurrencies[index]+", ";
					}
					for (let index = 5; index < splittedCurrencies.length; index++) {
						if((index + 1) == splittedCurrencies.length ){
							outputOther += splittedCurrencies[index];
						}else{
							outputOther += splittedCurrencies[index] + ", ";
						}
					}		
	
					output += 
						` Other <span title="${outputOther}" data-title="${outputOther}">
							<i data-component="icon" data-icon="icon-tooltip" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
								<path fill="#0089FF" fill-rule="evenodd" d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z"></path>
							</svg>
							</i>
						</span>
						`;
	
					valueContainer.innerHTML = output;	
				}
			}
		}
	}

	buttonContainer(storage: any) {
		let eligibilityExists: boolean = false;
		let eligibilityResult: any = '';
		let eligibilityLeadId: any = '';
		let eligibilityModalId: any = '';
		this.containerButtons.map((element) => {
			element.classList.add('d-none');
			let buttonContainer: any = element.getAttribute('data-buttonclass');
			let button: any = element.querySelector('.button');
			let buttonModalId: any = button.getAttribute('data-modal');
			for (let key in storage) {
				if (buttonModalId === key) {
					eligibilityExists = true;
					eligibilityResult = storage[key].result;
					eligibilityLeadId = storage[key].leadID;
					eligibilityModalId = key;
				}
			}
		});
		this.buttonStorage(eligibilityExists, eligibilityResult, eligibilityLeadId, eligibilityModalId);
	}

	buttonStorage(exists = false, result: any = '', leadid: any = '', modalId: any = '') {
		if (exists || this.queryStringCheck) {
			if (result == "apply" || this.queryStringCheck) {
				this.containerButtons.map((element) => {
					let buttonClass: any = element.getAttribute('data-buttonclass');
					let button: any = element.querySelector('.button');
					if (buttonClass === 'Apply' || buttonClass === 'Compare') {
						element.classList.remove('d-none');
						if(buttonClass === 'Apply'){
							button.setAttribute('href', 'javascript:void(0)');
							button.setAttribute('data-leadid', leadid);
						}
					}
				});
				this.containerEligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--eligible');
				this.containerEligibilityMessage.innerHTML = `You are eligible for this product.`;

			} else if (result == "callmeback") {
				this.containerButtons.map((element) => {
					let buttonClass: any = element.getAttribute('data-buttonclass');
					let button: any = element.querySelector('.button');
					if (buttonClass === 'CallMeBack' || buttonClass === 'Compare') {
						element.classList.remove('d-none');
						if(buttonClass === 'CallMeBack'){
							button.setAttribute('data-leadid', leadid);
						}
					}
				});
				this.containerEligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--eligible');
				this.containerEligibilityMessage.innerHTML = `You are eligible for this product.`;

			} else if (result == "contactus") {
				this.containerButtons.map((element) => {
					let buttonClass: any = element.getAttribute('data-buttonclass');
					let button: any = element.querySelector('.button');
					if (buttonClass === 'ContactUs' || buttonClass === 'Compare') {
						element.classList.remove('d-none');
					}
				});
				this.containerEligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--invalid');
				this.containerEligibilityMessage.innerHTML = `You are not eligible for this product. <a href="javascript:;" class="js-apply-now-modal-open js-recheck-eligibility" data-modal="${modalId}">Recheck</a>`;

			} else if (result == "notvalid") {
				this.containerButtons.map((element) => {
					let buttonClass: any = element.getAttribute('data-buttonclass');
					let button: any = element.querySelector('.button');
					if (buttonClass === 'ContactUs' || buttonClass === 'Compare') {
						element.classList.remove('d-none');
					}
				});
				this.containerEligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--invalid');
				this.containerEligibilityMessage.innerHTML = `You are not eligible for this product. <a href="javascript:;" class="js-apply-now-modal-open js-recheck-eligibility" data-modal="${modalId}">Recheck</a>`;

			} else {
				this.containerButtons.map((element) => {
					let buttonClass: any = element.getAttribute('data-buttonclass');
					let button: any = element.querySelector('.button');
					if (buttonClass === 'Eligibility' || buttonClass === 'Compare') {
						element.classList.remove('d-none');
					}
				});
			}
		} else {
			let eligibilityExists: any = false;
			this.containerButtons.map((element) => {
				let buttonClass: any = element.getAttribute('data-buttonclass');
				if (buttonClass === 'Eligibility') {
					eligibilityExists = true;
				}
			});
			this.containerButtons.map((element) => {
				let buttonClass: any = element.getAttribute('data-buttonclass');
				let button: any = element.querySelector('.button');
				if(eligibilityExists === false){
					if (buttonClass === 'ContactUs' || buttonClass === 'Compare') {
						element.classList.remove('d-none');
					}
				}else{
					if (buttonClass === 'Eligibility' || buttonClass === 'Compare') {
						element.classList.remove('d-none');
					}
				}
			});
		}
	}

	recheckEligibility(element: any) {
		if (element) {
			let modalId = element.getAttribute('data-modal');
			this.containerEligibilityMessage.innerHTML = '';
			delete this.eligibilityStorage[modalId];
			localStorage.setItem('eligibility', JSON.stringify(this.eligibilityStorage));
			this.buttonContainer(this.eligibilityStorage);
		}
	}

	actionApplyNow(leadId: any = '', productName: any = '') {

		let messageEligiblility = this.containerEligibilityMessage;

		let postData = '';
		if(this.queryStringCheck){
			postData += 'operation=submit_seafarer_referral&';
			postData += 'referralCode=' + this.queryStringValue +'&';
		}else{
			postData += 'operation=submit&';
			postData += 'leadID=' + leadId + '&';
		}
		postData += 'category=individual&';
		postData += 'productName=' + productName + '&';

		let analyticsService = new AnalyticsService();
		this.analyticsService.dtmFormStart("applynow " + productName);
		let url = "/services/SubmitWINLead.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, postData, config).then(function (response) {

			let json: any = response.data;

			if(json){

				let errors = json.Errors;
				if(errors.length > 0){
					errors.forEach(error => {
						analyticsService.dtmRecordSiteError('noerrorcode|' + error + '|' + url);
						messageEligiblility.classList.add('detailed-product-card-exchange__eligibility-message--invalid');
						if(error.includes('Unknown product')){
							messageEligiblility.innerHTML = 'Invalid request';
						}
						if(error.includes('Authorization')){
							messageEligiblility.innerHTML = 'Invalid request';
						}
						if(error.includes('undocumented')){
							messageEligiblility.innerHTML = 'Request failed – try again later';
						}
						if(error.includes('existing')){
							messageEligiblility.innerHTML = 'Your request has already been submitted';
						}
					});
				}else{
					let resources = json.Resources;
					if(resources){
						let lmm = resources.LMM;
						if(lmm){
							window.location = lmm;
							analyticsService.dtmFormComplete('complete', leadId);
						}
					}
				}
				
			}

		}).catch(function (response) {
			analyticsService.dtmRecordSiteError('noerrorcode|' + response + '|' + url);
		});

	}

	urlParams(name){
		var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
		if (results==null){
		   return null;
		}
		else{
		   return decodeURI(results[1]) || 0;
		}
	}

}



// WEBPACK FOOTER //
// ./components/detailed-product-card-exchange/detailed-product-card-exchange.component.ts